<script setup lang="ts">
    import type { ProductLabelFieldsFragment } from '~/graphql/generated';

    interface LabelProductProps {
        label: ProductLabelFieldsFragment;
    }

    const props = defineProps<LabelProductProps>();

    const showFullLabel = ref(false);

    const expandInfo = () => {
        showFullLabel.value = !showFullLabel.value;
    };

    const colorMap: Record<string, string> = {
        green: 'bg-woom-green text-white',
        yellow: 'bg-woom-yellow',
        grey: 'bg-woom-grey-moon text-white',
        lightgrey: 'bg-woom-grey-mid',
        black: 'bg-woom-black text-white',
        white: 'bg-woom-white',
    };

    const colorClasses = computed(() => {
        // red is default
        return colorMap[props.label?.color ?? ''] || 'bg-woom-red text-white';
    });
</script>

<template>
    <span
        :class="[
            'atm-product-label text z-10 overflow-hidden text-ellipsis rounded px-1 font-mono text-2xs lg:hover:whitespace-normal',
            colorClasses,
            showFullLabel ? 'whitespace-normal' : 'whitespace-nowrap',
        ]"
        @click="expandInfo">
        {{ label.label }}
    </span>
</template>
<style scoped>
    .atm-product-label {
        /* limit of 20 characters + px-1 */
        max-width: calc(20ch + 8px);
        padding-top: 1px;
        padding-bottom: 1px;
    }
</style>
